// extracted by mini-css-extract-plugin
export default {"secao":"Introducao_secao__O2i2f","texto-oni-azul":"Introducao_texto-oni-azul__bnNWl"};